module.exports = __webpack_public_path__ + "395ff59d447f1a06265eecb8b0531603.svg";